import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthentication } from '../../hooks/useAuthentication';
import { useInsertDocument } from '../../hooks/useInsertDocument';
import { useAuthValue } from '../../context/AuthContext';
import SignUpForm from '../../components/SignUpForm/SignUpForm';
import { Card } from '../../components/ui';

export default function Signup() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [birthday, setBirthday] = useState('');
  const [cellphone, setCellphone] = useState('');
  const [formError, setFormError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const { setDocument } = useInsertDocument('users');
  const { user: authUser } = useAuthValue();
  const { createUser, error: authError, loading, logout } = useAuthentication();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;

    setFormError('');

    // Todos os campos do formulario sao obrigatorios (o form usa noValidate,
    // entao a validacao precisa ser feita aqui). Ordem igual a dos campos.
    if (!name.trim()) {
      setFormError('Informe seu nome completo.');
      return;
    }

    if (!birthday) {
      setFormError('Informe sua data de nascimento.');
      return;
    }

    const phoneDigits = cellphone.replace(/\D/g, '');
    if (phoneDigits.length < 10) {
      setFormError('Informe um celular válido com DDD.');
      return;
    }

    if (!email.trim()) {
      setFormError('Informe seu email.');
      return;
    }

    if (!password) {
      setFormError('Informe uma senha.');
      return;
    }

    setSubmitting(true);

    try {
      const res = await createUser({ name, email, password });

      if (!res?.success || !res.user) {
        setFormError(res?.error || 'Não foi possível criar o usuário. Verifique os dados e tente novamente.');
        return;
      }

      const result = await setDocument(
        { name, email, birthday, cellphone, admin: false, id: res.user.uid },
        res.user.uid,
      );

      if (!result || !result.success) {
        setFormError(result?.error || 'Usuário criado, mas não foi possível salvar o perfil. Tente novamente.');
        await logout();
        return;
      }

      navigate('/profile');
    } finally {
      setSubmitting(false);
    }
  };

  React.useEffect(() => {
    if (authUser && !submitting) navigate('/profile');
  }, [authUser, navigate, submitting]);

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-12 bg-bg">
      <div className="w-full max-w-[440px]">
        <Card>
          <Card.Body className="py-8 px-6">
            <SignUpForm
              name={name} email={email} password={password}
              birthday={birthday} cellphone={cellphone}
              setName={setName} setEmail={setEmail} setPassword={setPassword}
              setBirthday={setBirthday} setCellphone={setCellphone}
              handleSubmit={handleSubmit}
              authError={authError || formError}
              loading={loading || submitting}
            />
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}
